import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import moment from 'moment';
import { HelpersService } from '../../../../../../services/helpers.service';
import { RentalsService } from '../../../../../../services/rentals.service';
import { CollectionsService } from '../../../../../../services/collections.service';
import { MessageService } from 'primeng/api';
import SignaturePad from 'signature_pad';
import { Subject, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Component({
  selector: 'app-book-rental-reservation',
  templateUrl: './book-rental-reservation.component.html',
  styleUrls: ['./book-rental-reservation.component.scss'],
  providers: [MessageService],
})
export class BookRentalReservationComponent implements OnInit {
  @Input() bookingInfo;
  @Input() categories;
  @Input() fullAccessoryList = [];
  @Input() brands;
  @Input() sizes;
  @Input() rentalStoreRules;
  @Output() close = new EventEmitter();

  public products: any = [];
  public accessoryOptions: any = [];
  public requiredAccessoryOptions: any = [];
  public loading: boolean = false;
  public bikesLoading: boolean = false;
  public loadingAvailability: boolean = true;
  public savingReservation: boolean = false;
  public partner: any = {};
  public minDate = moment(moment().format('YYYY-MM-DD')).toDate();
  public countryData: any = {};
  public selectedCategories: any = null;
  public selectedBrands: any = null;
  public selectedSizes: any = null;
  public filteredProducts: any = [];
  public currentTimes: string[] = [];
  public selectedProductsTmp: any = [];
  public disabledDates: any = [];
  public availableDates: any = [];
  public availableSlots: any = [];
  public overrideDateControl: boolean = false;
  public availableTimeUnits: any = [];
  public selectedTimeUnit: any = null;
  public rentalDaysMessage: string = '';
  public affiliates: any = [];
  public couponError : any = null;
  public verifyingCouponCode : boolean = false;
  public couponCodeValid : boolean = false;
  public addAffiliate : boolean = false;
  public addDelivery : boolean = false;

  public disabledDeliveryDates : any = [];
  public disabledCollectionDates : any = [];
  public deliveryTimeSlots : any = [];
  public collectionTimeSlots : any = [];
  public addressOptions : any = [];
  public deliveryAddressLoading : boolean = false;
  public collectionAddressLoading : boolean = false;
  public addressSearch : string = "";
  public availableDeliveryDates : any = [];
  public availableCollectionDates : any = [];
  public minCollectionDate = new Date();
  public maxCollectionDate = moment().add(2, 'year').toDate();

  private modelChanged: Subject<string> = new Subject<string>();
  private subscription: Subscription;
  debounceTime = 1500;

  public hasCouponsSetup = false;

  public modules = {
    toolbar: [
      ['bold', 'italic', 'underline'], // toggled buttons
      [{ list: 'ordered' }, { list: 'bullet' }],
      [{ indent: '-1' }, { indent: '+1' }], // outdent/indent
      ['clean'], // remove formatting button
    ],
  };

  //@ViewChild('calendar') calendar: Calendar;
  @ViewChild('canvas') canvas: ElementRef<HTMLCanvasElement>;
  public sig: SignaturePad;

  constructor(
    private helpersService: HelpersService,
    private rentalsService: RentalsService,
    public messageService: MessageService,
    private collectionsService : CollectionsService
  ) {}

  ngOnInit() {
    this.loading = true;
    this.partner = this.helpersService.getPartnerData();

    if (this.partner.HasCouponsSetup){
      this.hasCouponsSetup = true
    }

    this.countryData = this.helpersService.getCountryData();

    /*this.products = JSON.parse(JSON.stringify(this.products.map(x => { return x.extendedProps }))).map(product=>{return {...product, requiresAccessories : this.accessories.filter(x=>{return x.forceSelection && x.linkedProducts && x.linkedProducts.filter(y=>{return y.id === product.id}).length > 0}).length > 0}});
                                this.filteredProducts = this.products;*/

    document.documentElement.style.setProperty('--show-intercom', 'none');
    this.loading = false;

    if (this.canvas) {
      this.sig = new SignaturePad(this.canvas.nativeElement);
    }

    this.getAffiliates();
    this.bookingInfo.isDemo = this.bookingInfo.isDemo ? this.bookingInfo.isDemo :false;


    this.subscription = this.modelChanged
    .pipe(debounceTime(this.debounceTime))
    .subscribe(() => {
      this.verifyCouponCode();
    });

  }

  ngOnDestroy() {
    document.documentElement.style.setProperty('--show-intercom', 'inherit');
  }

  ngAfterViewInit(): void {
    if (this.bookingInfo.fromDate && this.bookingInfo.toDate) {
      setTimeout(() => {
        //this.calendar.currentYear = moment(this.bookingInfo.fromDate).get('year');
        //this.calendar.currentMonth = moment(this.bookingInfo.fromDate).get('month');
        //this.onMonthChange(true);
      }, 500);
      //this.getAvailableProducts(true);
    }
    this.getRentalAllowableTimeUnits();
  }

  inputChanged() {
    this.modelChanged.next(null);
  }

  getAffiliates() {
    this.rentalsService
      .getRentalAffiliatesBooking(this.helpersService.getPartnerId())
      .subscribe((affiliates: any) => {
        this.affiliates = affiliates.map((x) => {
          return { value: x.id, label: x.affiliateName };
        });
      });
  }

  getRentalAllowableTimeUnits() {
    this.rentalsService
      .getRentalAllowableTimeUnits(this.helpersService.getPartnerId())
      .subscribe((units) => {
        this.availableTimeUnits = units;
      });
  }

  getAvailableProducts(initial = false) {
    if (this.bookingInfo.fromDate && this.bookingInfo.toDate) {
      this.bikesLoading = true;
      var selectedProductIDs = this.products
        .filter((x) => {
          return x.selected;
        })
        .map((x) => {
          return x.id;
        });
      this.rentalsService
        .getAvailableRentalAvailableProductsAccessories(
          this.helpersService.getPartnerId(),
          moment(this.bookingInfo.fromDate).format('YYYY-MM-DD HH:mm'),
          moment(this.bookingInfo.toDate).format('YYYY-MM-DD HH:mm'),
          0,
          this.bookingInfo.isDemo
        )
        .subscribe(
          (result) => {
            this.products = result.products;
            this.accessoryOptions = result.accessoryOptions;
            this.requiredAccessoryOptions = result.requiredAccessoryOptions;

            //Mark and preselected products as selected after reload
            if (
              this.selectedProductsTmp &&
              this.selectedProductsTmp.length > 0
            ) {
              this.products.forEach((product) => {
                if (this.selectedProductsTmp.indexOf(product.id) > -1) {
                  product.selected = true;
                  product.accessoryOptions = JSON.parse(
                    JSON.stringify(this.accessoryOptions),
                  );
                  product.requredAccessoryOptions = JSON.parse(
                    JSON.stringify(
                      this.requiredAccessoryOptions.filter((x) => {
                        return (
                          x.linkedProducts.filter((y) => {
                            return y.productID == product.id;
                          }).length > 0
                        );
                      }),
                    ),
                  );
                }
              });
            }

            //Mark the initially selected product as selected
            if (this.bookingInfo.initiallySelectedProduct) {
              var product = this.products
                .filter((x) => {
                  return x.id === this.bookingInfo.initiallySelectedProduct;
                })
                .pop();
              if (product) {
                product.selected = true;
                product.accessoryOptions = JSON.parse(
                  JSON.stringify(this.accessoryOptions),
                );
                product.requredAccessoryOptions = JSON.parse(
                  JSON.stringify(
                    this.requiredAccessoryOptions.filter((x) => {
                      return (
                        x.linkedProducts.filter((y) => {
                          return y.productID == product.id;
                        }).length > 0
                      );
                    }),
                  ),
                );

                this.bookingInfo.initiallySelectedProduct = null;
                //this.addAccessoriesToProduct(product);

                // var index = this.products.map(x => { return x.id }).indexOf(this.bookingInfo.initiallySelectedProduct);
                // if (index > -1) {
                //   setTimeout(() => {
                //     var element = document.getElementById("product-container");
                //     element.scrollTo({ top: 0, left: index * (200 + 8), behavior: 'smooth' })
                //   }, 500);
                // }
              }
            } else if (selectedProductIDs && selectedProductIDs.length > 0) {
              this.products.forEach((p) => {
                if (selectedProductIDs.indexOf(p.id) > -1) {
                  p.selected = true;
                  p.accessoryOptions = JSON.parse(
                    JSON.stringify(this.accessoryOptions),
                  );
                  p.requredAccessoryOptions = JSON.parse(
                    JSON.stringify(
                      this.requiredAccessoryOptions.filter((x) => {
                        return (
                          x.linkedProducts.filter((y) => {
                            return y.productID == p.id;
                          }).length > 0
                        );
                      }),
                    ),
                  );
                }
              });
            }
            this.products = this.products.sort((x, y) => {
              if (x.selected && !y.selected) return -1;
              else if (!x.selected && y.selected) return 1;
              else return 0;
            });
            this.filteredProducts = this.products;
            setTimeout(() => {
              this.bikesLoading = false;
            }, 100);
          },
          (err) => {
            this.bikesLoading = false;
          },
        );
    }
  }

  addProduct(selectedProduct) {
    var product = this.products
      .filter((x) => {
        return x.id === selectedProduct.id;
      })
      .pop();
    if (product.selected) {
      product.selected = false;
    } else {
      product.accessoryOptions = JSON.parse(
        JSON.stringify(this.accessoryOptions),
      );
      product.requredAccessoryOptions = JSON.parse(
        JSON.stringify(
          this.requiredAccessoryOptions.filter((x) => {
            return (
              x.linkedProducts.filter((y) => {
                return y.productID == product.id;
              }).length > 0
            );
          }),
        ),
      );
      product.selected = true;
      //this.addAccessoriesToProduct(product);
    }
  }

  // addAccessoriesToProduct(product){
  //   product.requredAccessoryOptions = JSON.parse(JSON.stringify(this.accessories.filter(x=>{return x.forceSelection && x.linkedProducts && x.linkedProducts.filter(y=>{return y.id === product.id}).length > 0})));
  //   product.accessoryOptions = JSON.parse(JSON.stringify(this.accessories.filter(x=>{return !x.forceSelection})));
  // }

  addAccessory(accessory) {
    if (accessory.selected) {
      accessory.selected = false;
    } else {
      accessory.selected = true;
    }
  }

  hasRequiredAccessory(selectedProduct) {
    var product = this.products
      .filter((x) => {
        return x.id === selectedProduct.id;
      })
      .pop();
    const required = product?.requredAccessoryOptions ? product.requredAccessoryOptions : [];
    return required.length > 0 && this.allRequiredAccessoryGroupsSelected(required);
  }

  // Group the accessories linked to this product by category, so selecting any one
  // linked accessory in each required category (e.g. one of the linked pedals) satisfies it
  allRequiredAccessoryGroupsSelected(requiredAccessories) {
    const groups = new Map<string, boolean>();
    requiredAccessories.forEach((x) => {
      const key = x.categoryName;
      groups.set(key, groups.get(key) || (!!x.selected && x.available !== false));
    });
    return [...groups.values()].every((selected) => selected);
  }

  hasMandatoryQuestion(selectedProduct) {
    if (selectedProduct.customCategoryQuestions) {
      return (
        selectedProduct.customCategoryQuestions.filter((x) => {
          return x.mandatory && !x.response;
        }).length > 0
      );
    } else {
      return false;
    }
  }

  isAccessoryAlreadyUsed(accessory, type) {
    var accessoryUsed = false;
    if (
      this.products.filter((x) => {
        return x.selected;
      }).length > 0
    ) {
      this.products
        .filter((x) => {
          return x.selected;
        })
        .forEach((x) => {
          if (
            type === 'REQUIRED_ACCESSORY' &&
            x.requredAccessoryOptions &&
            x.requredAccessoryOptions.filter((y) => {
              return y.selected && y.id == accessory.id;
            }).length > 0
          ) {
            accessoryUsed = true;
          }
          if (
            type === 'OPTIONAL_ACCESSORY' &&
            x.accessoryOptions &&
            x.accessoryOptions.filter((y) => {
              return y.selected && y.id == accessory.id;
            }).length > 0
          ) {
            accessoryUsed = true;
          }
        });
    }
    return accessoryUsed;
  }

  calculateReservationTime() {
    var timeDiff = moment(this.bookingInfo.toDate).diff(
      this.bookingInfo.fromDate,
      'hour',
      false,
    );
    return { days: Math.floor(timeDiff / 24), hours: timeDiff % 24 };
  }

  addUser(user) {
    this.bookingInfo.userID = user.ID;
    this.couponCodeValid = false;
    if(this.bookingInfo.discountCode){
      this.verifyCouponCode()
    }
  }

  getSelectedProducts() {
    return this.products.filter((x) => {
      return x.selected;
    });
  }

  getProductFromID(id) {
    return this.products
      .filter((x) => {
        return x.id === id;
      })
      .pop();
  }

  setTempDisabledDates(fromDate: Date, toDate: Date) {
    this.disabledDates = [];
    var i = 0;
    for (var d = fromDate; d <= toDate; d = moment(d).add(1, 'day').toDate()) {
      this.disabledDates.push(d);
    }
  }

  // onMonthChange(initialLoad = false) {
  //   this.loadingAvailability = true;
  //   var startDate = moment(new Date(this.calendar.currentYear, this.calendar.currentMonth, 1)).format("YYYY-MM-DD");
  //   var endDate = moment(moment(startDate).endOf('month').add(1, 'day').toDate()).format("YYYY-MM-DD");
  //   this.setTempDisabledDates(new Date(startDate), new Date(endDate));
  //   this.rentalsService.getRentalAvailability(this.partner.ID, startDate, endDate).subscribe(availability => {
  //     this.disabledDates = availability.unavailableDates.map(x => { return new Date(x.date) });
  //     this.availableDates = availability.availableDates;
  //     if (this.bookingInfo.fromDate && initialLoad) {
  //       this.fromDateSelected(this.bookingInfo.fromDate, initialLoad)
  //     }
  //     this.loadingAvailability = false;
  //   }, err => {
  //     this.loadingAvailability = false;
  //   })
  // }

  // fromDateSelected(event, initialLoad = false) {
  //   var selectedDate = this.availableDates.filter((x: any) => { return moment(x.date).format("YYYY-MM-DD") === moment(event).format("YYYY-MM-DD") }).pop();
  //   if(selectedDate && selectedDate.availableSlots){
  //     this.availableSlots = selectedDate.availableSlots.map((x: any) => { return { ...x, label: moment('1970-01-01T' + x.value).format("h:mma") } });

  //     this.bookingInfo.toDate = !initialLoad ? null : this.bookingInfo.toDate;
  //     this.bookingInfo.selectedSlot = !initialLoad ? null : this.bookingInfo.selectedSlot;
  //     this.bookingInfo.selectedDuration = !initialLoad ? null : this.bookingInfo.selectedDuration;
  //     if (initialLoad && this.availableSlots) {
  //       var time = moment(this.bookingInfo.fromDate).format("HH:mm:ss");
  //       var slot = this.availableSlots.filter(x => { return x.value === time }).pop();
  //       if (slot) {
  //         this.slotSelected(slot, initialLoad);
  //       }
  //     }
  //   }

  // }

  // slotSelected(slot: any, initialLoad = false) {
  //   this.bookingInfo.selectedSlot = slot;
  //   this.bookingInfo.selectedDuration = null;
  //   if (initialLoad) {
  //     var duration = this.calculateReservationTime();
  //     if(slot && slot.durations){
  //       var selectedDuration = slot.durations.filter(x => { return x.unit === duration.hours && x.unitType === 'Hour' }).pop();
  //       if (selectedDuration) {
  //         this.durationSelected(selectedDuration, initialLoad);
  //       }
  //     }
  //   }
  // }

  // durationSelected(duration: any, initialLoad = false) {
  //   this.bookingInfo.selectedDuration = duration;
  //   var fromDate = moment(this.bookingInfo.fromDate).format("YYYY-MM-DD") + "T" + this.bookingInfo.selectedSlot.value;
  //   var toDate = moment(moment(this.bookingInfo.fromDate).format("YYYY-MM-DD") + "T" + this.bookingInfo.selectedSlot.value).add(this.bookingInfo.selectedDuration.unit, this.bookingInfo.selectedDuration.unitType).format("YYYY-MM-DDTHH:mm:ss");
  //   var timeUnitID = this.bookingInfo.selectedDuration.timeUnitID;
  //   this.bookingInfo.fromDate = moment(fromDate).toDate();
  //   this.bookingInfo.toDate = moment(toDate).toDate();
  //   if (this.bookingInfo.fromDate && this.bookingInfo.toDate) {
  //     this.getAvailableProducts(initialLoad);
  //   } else {
  //     this.products = [];
  //     this.filteredProducts = [];
  //   }
  // }

  dateOverrideUpdated() {
    if (this.overrideDateControl) {
      this.dateUpdated();
    }
  }

  dateUpdated() {
    this.selectedTimeUnit = null;
    this.bookingInfo.rentalDays = 0;
    this.bookingInfo.useFlexibleTimes = false;
    if (
      this.bookingInfo.fromDate &&
      this.bookingInfo.toDate &&
      this.showFixedSlots()
    ) {
      this.getAvailableProducts(false);

      var hours = 0;
      var days = 0;
      var weeks = 0;
      var months = 0;
      hours = moment(this.bookingInfo.toDate).diff(
        this.bookingInfo.fromDate,
        'hours',
        false,
      );
      days = moment(this.bookingInfo.toDate).diff(
        this.bookingInfo.fromDate,
        'days',
        false,
      );
      weeks = moment(this.bookingInfo.toDate).diff(
        this.bookingInfo.fromDate,
        'weeks',
        false,
      );
      months = moment(this.bookingInfo.toDate).diff(
        this.bookingInfo.fromDate,
        'months',
        false,
      );

      if (
        this.availableTimeUnits.filter((x) => {
          return x.unitTypeID === 4 && x.unit === months;
        }).length > 0
      ) {
        this.selectedTimeUnit = this.availableTimeUnits
          .filter((x) => {
            return x.unitTypeID === 4 && x.unit === months;
          })
          .pop();
      } else if (
        this.availableTimeUnits.filter((x) => {
          return x.unitTypeID === 3 && x.unit === weeks;
        }).length > 0
      ) {
        this.selectedTimeUnit = this.availableTimeUnits
          .filter((x) => {
            return x.unitTypeID === 3 && x.unit === weeks;
          })
          .pop();
      } else if (
        this.availableTimeUnits.filter((x) => {
          return x.unitTypeID === 2 && x.unit === days;
        }).length > 0
      ) {
        this.selectedTimeUnit = this.availableTimeUnits
          .filter((x) => {
            return x.unitTypeID === 2 && x.unit === days;
          })
          .pop();
      } else if (
        this.availableTimeUnits.filter((x) => {
          return x.unitTypeID === 1 && x.unit === hours;
        }).length > 0
      ) {
        this.selectedTimeUnit = this.availableTimeUnits
          .filter((x) => {
            return x.unitTypeID === 1 && x.unit === hours;
          })
          .pop();
      }
    } else if (
      this.bookingInfo.fromDate &&
      this.bookingInfo.toDate &&
      this.showFlexibleOptions()
    ) {
      this.getAvailableProducts(false);

      var hours = moment(this.bookingInfo.toDate).diff(
        this.bookingInfo.fromDate,
        'hours',
      );
      var days = Math.round(
        moment(this.bookingInfo.toDate).diff(
          this.bookingInfo.fromDate,
          'days',
          true,
        ),
      );

      if (this.rentalStoreRules.flexibleReservationConfiguration.addExtraDay) {
        days += 1;
      }
      if (days == 0) {
        days += 1;
      }

      if (hours / 24.0 > days) {
        this.rentalDaysMessage = 'OVER';
        this.bookingInfo.rentalDays = days + 1;
      } else if (hours / 24.0 < days) {
        this.rentalDaysMessage = 'UNDER';
        this.bookingInfo.rentalDays = days;
      } else {
        this.rentalDaysMessage = 'EXACT';
        this.bookingInfo.rentalDays = days;
      }

      if(this.bookingInfo.rentalDays && this.rentalStoreRules.flexibleReservationConfiguration.minimumDurationUnitType == 2 && this.bookingInfo.rentalDays > this.rentalStoreRules.flexibleReservationConfiguration.maximumDurationValue){
        this.bookingInfo.rentalDays = this.rentalStoreRules.flexibleReservationConfiguration.maximumDurationValue;
      }
      this.bookingInfo.useFlexibleTimes = true;
    } else {
      this.products = [];
      this.filteredProducts = [];
    }
    this.couponCodeValid = false;
    if(this.bookingInfo.discountCode){
      this.verifyCouponCode()
    }
  }

  // datePickerFocused(event) {
  //   this.selectedProductsTmp = this.products.filter(x => { return x.selected }).map(x => { return x.id });
  // }

  // datePickerClosed(event) {
  //   if (this.bookingInfo.fromDate && !this.bookingInfo.toDate) {
  //     this.getAvailableProducts();
  //   }
  // }

  filterRentalProducts() {
    this.filteredProducts = this.products;

    if (this.selectedCategories) {
      this.filteredProducts = this.filteredProducts.filter((x) => {
        return x.categoryName === this.selectedCategories;
      });
    }
    if (this.selectedBrands) {
      this.filteredProducts = this.filteredProducts.filter((x) => {
        return x.brand === this.selectedBrands;
      });
    }
  }

  selectCategoryFilter(value) {
    if (value === this.selectedCategories) {
      this.selectedCategories = null;
    } else {
      this.selectedCategories = value;
    }
    this.filterRentalProducts();
    //this.setFilters();
  }

  selectBrandFilter(value) {
    if (value === this.selectedBrands) {
      this.selectedBrands = null;
    } else {
      this.selectedBrands = value;
    }
    this.filterRentalProducts();
    //this.setFilters();
  }

  setSearch(value) {
    console.log(value)
    this.filteredProducts = this.products.filter((x) => {
      return (
        x.brand.toLowerCase().indexOf(value.toLowerCase()) > -1 ||
        x.model.toLowerCase().indexOf(value.toLowerCase()) > -1 ||
        x.categoryName.toLowerCase().indexOf(value.toLowerCase()) > -1 ||
        (x.serialNumber && x.serialNumber.toLowerCase().indexOf(value.toLowerCase()) > -1)
      );
    });
  }

  isValid() {
    var selectedProductsHasRequiredOptions = this.getSelectedProducts().every((x) => {
      const required = x.requredAccessoryOptions ? x.requredAccessoryOptions : [];
      return (!x.requiresAccessories || required.length > 0) && this.allRequiredAccessoryGroupsSelected(required);

    });

    var hasMandatoryCustomQuestion = false;
    this.getSelectedProducts().forEach((product) => {
      if (
        product.customCategoryQuestions &&
        product.customCategoryQuestions.filter((x) => {
          return x.mandatory && !x.response;
        }).length > 0
      ) {
        hasMandatoryCustomQuestion = true;
      }
    });
    if (!this.overrideDateControl) {
      return (
        this.bookingInfo.userID > 0 &&
        this.getSelectedProducts().length > 0 &&
        this.bookingInfo.selectedSlot &&
        (this.bookingInfo.selectedDuration ||
          this.bookingInfo.selectedReturnSlot) &&
        this.bookingInfo.fromDate > this.minDate &&
        this.bookingInfo.toDate > this.minDate &&
        this.bookingInfo.toDate > this.bookingInfo.fromDate &&
        selectedProductsHasRequiredOptions &&
        !hasMandatoryCustomQuestion
      );
    } else {
      return (
        this.bookingInfo.userID > 0 &&
        this.getSelectedProducts().length > 0 &&
        this.bookingInfo.fromDate &&
        this.bookingInfo.toDate &&
        this.bookingInfo.toDate > this.bookingInfo.fromDate &&
        (this.selectedTimeUnit || this.bookingInfo.rentalDays > 0) &&
        selectedProductsHasRequiredOptions &&
        !hasMandatoryCustomQuestion
      );
    }
  }

  createReservation() {
    this.savingReservation = true;
    var data = {
      defaultPartnerID: this.partner.ID,
      userID: this.bookingInfo.userID,
      fromDate: moment(this.bookingInfo.fromDate).format('YYYY-MM-DD HH:mm'),
      toDate: moment(this.bookingInfo.toDate).format('YYYY-MM-DD HH:mm'),
      isDemo: this.bookingInfo.isDemo,
      storeNotes: this.bookingInfo.storeNotes,
      clientNotes: this.bookingInfo.clientNotes,
      linkedRentalProducts: this.products
        .filter((product) => {
          return product.selected;
        })
        .map((product) => {
          return {
            ProductID: product.id,
            AccessoryOptions: product.accessoryOptions
              ? product.accessoryOptions
                  .filter((accessory) => {
                    return accessory.selected;
                  })
                  .map((accessory) => {
                    return { AccessoryID: accessory.id, Mandatory: false };
                  })
              : [],
            RequiredAccessoryOptions: product.requredAccessoryOptions
              ? product.requredAccessoryOptions
                  .filter((accessory) => {
                    return accessory.selected;
                  })
                  .map((accessory) => {
                    return { AccessoryID: accessory.id, Mandatory: true };
                  })
              : [],
            CustomCategoryQuestions: product.customCategoryQuestions
              ? product.customCategoryQuestions
              : [],
          };
        }),
      Waiver: this.isSignatureValid()
        ? {
            SignedDate: new Date(),
            WaiverTerms: this.rentalStoreRules.waiverTerms,
            SignatureData: this.canvas.nativeElement
              .toDataURL()
              .replace(/^data:(.*;base64,)?/, ''),
          }
        : null,
      OverrideDate: this.overrideDateControl,
      TimeUnitID: this.selectedTimeUnit ? this.selectedTimeUnit.id : null,
      UseFlexibleTimes: this.bookingInfo.useFlexibleTimes,
      UnitType: this.bookingInfo.unitType,
      RentalDays: this.bookingInfo.rentalDays && this.rentalStoreRules.flexibleReservationConfiguration.minimumDurationUnitType == 2 && this.bookingInfo.rentalDays > this.rentalStoreRules.flexibleReservationConfiguration.maximumDurationValue ? this.rentalStoreRules.flexibleReservationConfiguration.maximumDurationValue : this.bookingInfo.rentalDays,
      AffiliateID: this.bookingInfo.affiliateID,
      CouponCode: this.couponCodeValid && this.bookingInfo.discountCode ? this.bookingInfo.discountCode : "",
      deliveryInformation: this.bookingInfo.deliveryInformation.isDelivery ? this.bookingInfo.deliveryInformation : null,
      collectionInformation: this.bookingInfo.collectionInformation.isCollection ? this.bookingInfo.collectionInformation : null
    };
    if(data && data.deliveryInformation && data.deliveryInformation.isDelivery && data.deliveryInformation.scheduleDate){
      data.deliveryInformation.scheduleDate = moment(data.deliveryInformation.scheduleDate).format("YYYY-MM-DD");
    }
    if(data && data.collectionInformation && data.collectionInformation.isCollection && data.collectionInformation.scheduleDate){
      data.collectionInformation.scheduleDate = moment(data.collectionInformation.scheduleDate).format("YYYY-MM-DD");
    }
    if(data && data.deliveryInformation && data.deliveryInformation.fullAddress && data.deliveryInformation.fullAddress.address){
      data.deliveryInformation.fullAddress = data.deliveryInformation.fullAddress.address;
    }
    if(data && data.collectionInformation && data.collectionInformation.fullAddress && data.collectionInformation.fullAddress.address){
      data.collectionInformation.fullAddress = data.collectionInformation.fullAddress.address;
    }

    this.rentalsService.createRentalReservation(data).subscribe(
      (res) => {
        this.savingReservation = false;
        this.close.emit({});
      },
      (err) => {
        this.savingReservation = false;
      },
    );
  }

  getSelectedCount(accessories) {
    return accessories
      ? accessories.filter((x) => {
          return x.selected;
        }).length
      : 0;
  }

  clear() {
    this.sig.clear();
  }

  isSignatureValid() {
    return (
      this.canvas &&
      this.canvas.nativeElement.toDataURL() !==
        'data:image/png;base64,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'
    );
  }

  showFixedSlots() {
    return (
      !this.rentalStoreRules.allowFlexibleRentalOptions ||
      (this.rentalStoreRules.allowFixedRentalOptions &&
        moment(this.bookingInfo.fromDate).format('YYYY-MM-DD') ==
          moment(this.bookingInfo.toDate).format('YYYY-MM-DD'))
    );
  }

  showFlexibleOptions() {
    return (
      !this.rentalStoreRules.allowFixedRentalOptions ||
      (this.rentalStoreRules.allowFlexibleRentalOptions &&
        moment(this.bookingInfo.fromDate).format('YYYY-MM-DD') !==
          moment(this.bookingInfo.toDate).format('YYYY-MM-DD'))
    );
  }

  getFromDateTime() {
    return moment(this.bookingInfo.fromDate).format('h:mma');
  }

  verifyCouponCode(){
    this.verifyingCouponCode = true;
    this.couponError = null;

    const couponData = {
      PartnerID : this.helpersService.getPartnerId(),
      AffiliateID : this.bookingInfo.affiliateID,
      CouponCode: this.bookingInfo.discountCode,
      FromDate: this.bookingInfo.fromDate,
      UserID: this.bookingInfo.userID
    }

    this.rentalsService.validateCouponCode(couponData).subscribe(res=>{
      this.verifyingCouponCode = false;
      this.couponError = null;
      this.couponCodeValid = true;
    }, err=>{
      console.log(err)
      this.verifyingCouponCode = false;
      this.couponError = err && err.error ? err.error.message : '';
      this.couponCodeValid = false;
    });
  }


  addDeliveryCollections(){
    this.bookingInfo.deliveryInformation.isDelivery = true;
    this.bookingInfo.collectionInformation.isCollection = true;
    this.addDelivery = true;
    this.overrideDateControl = true;

  }






  datesUpdated(){
    this.selectedTimeUnit = null;
    this.bookingInfo.rentalDays = 0;
    this.bookingInfo.useFlexibleTimes = false;
    if (
      this.bookingInfo.fromDate &&
      this.bookingInfo.toDate &&
      this.showFixedSlots()
    ) {
      this.getAvailableProducts(false);

      var hours = 0;
      var days = 0;
      var weeks = 0;
      var months = 0;
      hours = moment(this.bookingInfo.toDate).diff(
        this.bookingInfo.fromDate,
        'hours',
        false,
      );
      days = moment(this.bookingInfo.toDate).diff(
        this.bookingInfo.fromDate,
        'days',
        false,
      );
      weeks = moment(this.bookingInfo.toDate).diff(
        this.bookingInfo.fromDate,
        'weeks',
        false,
      );
      months = moment(this.bookingInfo.toDate).diff(
        this.bookingInfo.fromDate,
        'months',
        false,
      );

      if (
        this.availableTimeUnits.filter((x) => {
          return x.unitTypeID === 4 && x.unit === months;
        }).length > 0
      ) {
        this.selectedTimeUnit = this.availableTimeUnits
          .filter((x) => {
            return x.unitTypeID === 4 && x.unit === months;
          })
          .pop();
      } else if (
        this.availableTimeUnits.filter((x) => {
          return x.unitTypeID === 3 && x.unit === weeks;
        }).length > 0
      ) {
        this.selectedTimeUnit = this.availableTimeUnits
          .filter((x) => {
            return x.unitTypeID === 3 && x.unit === weeks;
          })
          .pop();
      } else if (
        this.availableTimeUnits.filter((x) => {
          return x.unitTypeID === 2 && x.unit === days;
        }).length > 0
      ) {
        this.selectedTimeUnit = this.availableTimeUnits
          .filter((x) => {
            return x.unitTypeID === 2 && x.unit === days;
          })
          .pop();
      } else if (
        this.availableTimeUnits.filter((x) => {
          return x.unitTypeID === 1 && x.unit === hours;
        }).length > 0
      ) {
        this.selectedTimeUnit = this.availableTimeUnits
          .filter((x) => {
            return x.unitTypeID === 1 && x.unit === hours;
          })
          .pop();
      }
    } else if (
      this.bookingInfo.fromDate &&
      this.bookingInfo.toDate &&
      this.showFlexibleOptions()
    ) {
      this.getAvailableProducts(false);

      var hours = moment(this.bookingInfo.toDate).diff(
        this.bookingInfo.fromDate,
        'hours',
      );
      var days = Math.round(
        moment(this.bookingInfo.toDate).diff(
          this.bookingInfo.fromDate,
          'days',
          true,
        ),
      );

      if (this.rentalStoreRules.flexibleReservationConfiguration.addExtraDay) {
        days += 1;
      }
      if (days == 0) {
        days += 1;
      }

      if (hours / 24.0 > days) {
        this.rentalDaysMessage = 'OVER';
        this.bookingInfo.rentalDays = days + 1;
      } else if (hours / 24.0 < days) {
        this.rentalDaysMessage = 'UNDER';
        this.bookingInfo.rentalDays = days;
      } else {
        this.rentalDaysMessage = 'EXACT';
        this.bookingInfo.rentalDays = days;
      }
      if(this.bookingInfo.rentalDays && this.rentalStoreRules.flexibleReservationConfiguration.minimumDurationUnitType == 2 && this.bookingInfo.rentalDays > this.rentalStoreRules.flexibleReservationConfiguration.maximumDurationValue){
        this.bookingInfo.rentalDays = this.rentalStoreRules.flexibleReservationConfiguration.maximumDurationValue;
      }
      this.bookingInfo.useFlexibleTimes = true;
    } else {
      this.products = [];
      this.filteredProducts = [];
    }
  }

  searchAddress(address, type){
    this.addressSearch = address.query;
    if (type === 'COLLECTION') {
      this.bookingInfo.collectionInformation.googlePlaceID = null;
      this.collectionsService
        .getAddressOptions(
          address.query,
          this.partner.Country === 'GB' && address.query.length <= 8
            ? 'GB'
            : '',
        )
        .subscribe((res) => {
          this.addressOptions = res.predictions.map((x) => {
            return { address: x.description, placeID: x.place_id };
          });
        });
    } else {
      this.bookingInfo.deliveryInformation.googlePlaceID = null;
      this.collectionsService
        .getAddressOptions(
          address.query,
          this.partner.Country === 'GB' && address.query.length <= 8
            ? 'GB'
            : '',
        )
        .subscribe((res) => {
          this.addressOptions = res.predictions.map((x) => {
            return { address: x.description, placeID: x.place_id };
          });
        });
    }
  }

  onAddressSelect(event, type){
    if (type === 'COLLECTION') {
      this.collectionAddressLoading = true;
      this.bookingInfo.collectionInformation.googlePlaceID = event.placeID;
      if (!event.placeID) {
        this.getAddressPlaceDetails(type, true);
      } else {
        this.getLocationFromAddress(event.address, type);
      }
    } else {
      this.deliveryAddressLoading = true;
      this.bookingInfo.deliveryInformation.googlePlaceID = event.placeID;
      if (!event.placeID) {
        this.getAddressPlaceDetails(type, true);
      } else {
        this.getLocationFromAddress(event.address, type);
      }
    }
  }

  async getAddressPlaceDetails(type, locationFromAddress = false) {
    if (type === 'COLLECTION') {
      await this.collectionsService
        .getAddressOptions(this.bookingInfo.collectionInformation.fullAddress.address, `${0},${0}`)
        .subscribe((res) => {
          this.bookingInfo.collectionInformation.googlePlaceID =
            res.predictions && res.predictions.length > 0
              ? res.predictions[0].place_id
              : 'N/A';
          if (locationFromAddress && this.bookingInfo.collectionInformation.googlePlaceID) {
            this.getLocationFromAddress(
              this.bookingInfo.collectionInformation.fullAddress.address,
              type,
            );
          }
        });
    } else {
      await this.collectionsService
        .getAddressOptions(this.bookingInfo.deliveryInformation.fullAddress.address, `${0},${0}`)
        .subscribe((res) => {
          this.bookingInfo.deliveryInformation.googlePlaceID =
            res.predictions && res.predictions.length > 0
              ? res.predictions[0].place_id
              : 'N/A';
          if (locationFromAddress && this.bookingInfo.deliveryInformation.googlePlaceID) {
            this.getLocationFromAddress(
              this.bookingInfo.deliveryInformation.fullAddress.address,
              type,
            );
          }
        },err=>{
        });
    }
  }

  getLocationFromAddress(address, type, reset = true) {
    this.collectionsService
      .getLocationFromAddress(
        address +
          (this.partner.Country === 'GB' && this.addressSearch.length <= 8
            ? ', ' + this.addressSearch + ', UK'
            : ''),
      )
      .subscribe(async (res) => {
        const data = {
          PartnerID: this.partner.ID,
          IsCollection: type === 'COLLECTION',
          IsDelivery: type === 'DELIVERY',
          Latitude: res.lat,
          Longitude: res.lng,
          CurrentLocalTime: moment().format('YYYY-MM-DDTHH:mm:ss'),
        };

        if (
          (type === 'COLLECTION' && !this.bookingInfo.collectionInformation.googlePlaceID) ||
          (type === 'DELIVERY' && !this.bookingInfo.deliveryInformation.googlePlaceID)
        ) {
          await this.getAddressPlaceDetails(type, true);
          return;
        }
        this.collectionsService.checkRentalAddressInRange(data).subscribe(
          (addressInfo: any) => {
            if (
              addressInfo &&
              addressInfo.partnerID == this.partner.ID
            ) {
              if (type === 'COLLECTION') {
                this.collectionsService
                  .getGooglePlaceInfo(this.bookingInfo.collectionInformation.googlePlaceID)
                  .subscribe((placeInfo) => {
                    this.setAddressInfo(placeInfo, type);
                  });
                this.bookingInfo.collectionInformation.addressOutOfRange = false;
                this.bookingInfo.collectionInformation.distanceToPartner = addressInfo.distanceToStore;
                this.bookingInfo.collectionInformation.areaID = addressInfo.areaID;
                var fromDate = moment(
                  this.bookingInfo.collectionInformation.scheduleDate || this.minDate,
                )
                  .startOf('month')
                  .format('YYYY-MM-DD');
                this.getAvailability(fromDate, reset, true, false);
              } else {
                this.collectionsService
                  .getGooglePlaceInfo(this.bookingInfo.deliveryInformation.googlePlaceID)
                  .subscribe((placeInfo) => {
                    this.setAddressInfo(placeInfo, type);
                  });
                this.bookingInfo.deliveryInformation.addressOutOfRange = false;
                this.bookingInfo.deliveryInformation.distanceToPartner = addressInfo.distanceToStore;
                this.bookingInfo.deliveryInformation.areaID = addressInfo.areaID;
                var fromDate = moment(
                  this.bookingInfo.deliveryInformation.scheduleDate || this.minDate,
                )
                  .startOf('month')
                  .format('YYYY-MM-DD');
                this.getAvailability(fromDate, reset, false, true);
              }
            } else {
              if (type === 'COLLECTION') {
                this.bookingInfo.collectionInformation.addressOutOfRange = true;
                this.bookingInfo.collectionInformation.distanceToPartner = -1;
                this.bookingInfo.collectionInformation.areaID = 0;
                this.collectionAddressLoading = false;
                this.bookingInfo.collectionInformation.timeSlot = {};
                this.bookingInfo.collectionInformation.scheduleDate = null;
              } else {
                this.bookingInfo.deliveryInformation.addressOutOfRange = true;
                this.bookingInfo.deliveryInformation.distanceToPartner = -1;
                this.bookingInfo.deliveryInformation.areaID = 0;
                this.deliveryAddressLoading = false;
                this.bookingInfo.deliveryInformation.timeSlot = {};
                this.bookingInfo.deliveryInformation.scheduleDate = null;
              }
            }
          },
          (err) => {
            if (type === 'COLLECTION') {
              this.bookingInfo.collectionInformation.addressOutOfRange = true;
              this.bookingInfo.collectionInformation.distanceToPartner = -1;
              this.bookingInfo.collectionInformation.areaID = 0;
              this.collectionAddressLoading = false;
              this.bookingInfo.collectionInformation.timeSlot = {};
              this.bookingInfo.collectionInformation.scheduleDate = null;
            } else {
              this.bookingInfo.deliveryInformation.addressOutOfRange = true;
              this.bookingInfo.deliveryInformation.distanceToPartner = -1;
              this.bookingInfo.deliveryInformation.areaID = 0;
              this.deliveryAddressLoading = false;
              this.bookingInfo.deliveryInformation.timeSlot = {};
              this.bookingInfo.deliveryInformation.scheduleDate = null;
            }
          },
        );
      });
  }

  getAvailability(
    fromDate: string,
    reset = true,
    collection = false,
    delivery = false,
  ) {
    if (
      (collection && this.bookingInfo.collectionInformation.areaID) ||
      (delivery && this.bookingInfo.deliveryInformation.areaID)
    ) {
      const data = {
        PartnerID: this.partner.ID,
        FromDate: moment(fromDate).add('days', -7).format('YYYY-MM-DD'),
        ToDate: moment(fromDate)
          .add('month', 2)
          .endOf('month')
          .format('YYYY-MM-DD'),
        CurrentLocalTime: moment().format('YYYY-MM-DDTHH:mm:ss'),
        IsCollection: collection,
        IsDelivery: delivery,
        AreaID: collection
          ? this.bookingInfo.collectionInformation.areaID
          : delivery
            ? this.bookingInfo.deliveryInformation.areaID
            : 0,
        //"ServiceTypes": collection ? this.jobcard.Types.map(x=>{return x.TypeID}).join(",") : null
      };
      var invalidDates = JSON.parse(
        JSON.stringify(
          collection
            ? this.disabledCollectionDates
            : delivery
              ? this.disabledDeliveryDates
              : [],
        ),
      );
      invalidDates = invalidDates.map((x) => {
        return new Date(x);
      });
      this.rentalsService.getAvailableDeliveryCollectionDates(data).subscribe(
        (response: any) => {
          if (response.availableDates && response.availableDates.length > 0) {
            if (collection) {
              this.availableCollectionDates = response.availableDates;
            } else {
              this.availableDeliveryDates = response.availableDates;
            }
            response.availableDates.forEach((availableDate: any) => {
              var index = invalidDates
                .map((x) => {
                  return moment(x).format('YYYY-MM-DD');
                })
                .indexOf(
                  moment(availableDate.availableDate).format('YYYY-MM-DD'),
                );
              if (index > -1) {
                invalidDates.splice(index, 1);
              }
            });
            if (collection) {
              this.disabledCollectionDates = invalidDates;
            } else {
              this.disabledDeliveryDates = invalidDates;
            }

            if (!reset) {
              this.setBookingDate(
                reset,
                collection ? 'COLLECTION' : delivery ? 'DELIVERY' : '',
              );
            }
          }
          if (
            response.unavailableDates &&
            response.unavailableDates.length > 0
          ) {
            response.unavailableDates.map((x) => {
              var d = new Date(x.unavailableDate);
              d.setHours(0);
              d.setMinutes(0);
              d.setSeconds(0);
              d.setMilliseconds(0);
              var index = collection
                ? this.disabledCollectionDates.findIndex((x) => {
                    return x.valueOf() === d.valueOf();
                  })
                : this.disabledDeliveryDates.findIndex((x) => {
                    return x.valueOf() === d.valueOf();
                  });
              if (index === -1) {
                if (collection) {
                  this.disabledCollectionDates.push(d);
                } else {
                  this.disabledDeliveryDates.push(d);
                }
              }
            });
          }

          this.collectionAddressLoading = false;
          this.deliveryAddressLoading = false;
        },
        (err) => {

          this.collectionAddressLoading = false;
          this.deliveryAddressLoading = false;
        },
      );
    } else {

      this.collectionAddressLoading = false;
      this.deliveryAddressLoading = false;
    }
  }

  setAddressInfo(placeInfo, type) {
    if (placeInfo) {
      var GooglePlace = JSON.parse(placeInfo).result;
      var addressDetails = {
        street_no: null,
        street_address: null,
        city: null,
        country: null,
        postal_code: null,
        latitude: null,
        longitude: null,
      };
      if (GooglePlace && GooglePlace.address_components) {
        var street_no = GooglePlace.address_components
          .filter((x) => {
            return x.types.indexOf('street_number') > -1;
          })
          .pop();
        if (street_no) {
          addressDetails.street_no = street_no.long_name;
        }
        var street_address = GooglePlace.address_components
          .filter((x) => {
            return x.types.indexOf('route') > -1;
          })
          .pop();
        if (street_address) {
          addressDetails.street_address = street_address.long_name;
        }
        var city = GooglePlace.address_components
          .filter((x) => {
            return x.types.indexOf('postal_town') > -1;
          })
          .pop();
        if (city) {
          addressDetails.city = city.long_name;
        }
        if (!city) {
          var city = GooglePlace.address_components
            .filter((x) => {
              return x.types.indexOf('locality') > -1;
            })
            .pop();
          if (city) {
            addressDetails.city = city.long_name;
          }
        }

        var country = GooglePlace.address_components
          .filter((x) => {
            return x.types.indexOf('country') > -1;
          })
          .pop();
        if (country) {
          addressDetails.country = country.long_name;
        }
        var postal_code = GooglePlace.address_components
          .filter((x) => {
            return x.types.indexOf('postal_code') > -1;
          })
          .pop();
        if (postal_code) {
          addressDetails.postal_code = postal_code.long_name;
        }
        addressDetails.latitude = GooglePlace.geometry.location.lat;
        addressDetails.longitude = GooglePlace.geometry.location.lng;
        if (type === 'COLLECTION') {
          this.bookingInfo.collectionInformation.addressDetails = addressDetails;
          this.bookingInfo.collectionInformation.postalCode = addressDetails.postal_code;
        } else {
          this.bookingInfo.deliveryInformation.addressDetails = addressDetails;
          this.bookingInfo.deliveryInformation.postalCode = addressDetails.postal_code;
          if(!this.bookingInfo.collectionInformation.fullAddress){
            this.bookingInfo.collectionInformation.fullAddress = this.bookingInfo.deliveryInformation.fullAddress;
            this.bookingInfo.collectionInformation.addressDetails = addressDetails;
            this.bookingInfo.collectionInformation.postalCode = addressDetails.postal_code;
            this.bookingInfo.collectionInformation.areaID = this.bookingInfo.deliveryInformation.areaID;
            this.getAvailability(this.bookingInfo.fromDate, false, true, false);
          }
        }
      }
    }
  }

  deliveryDateSelected(event){
    this.setBookingDate(false, "DELIVERY");
  }

  collectionDateSelected(event){
    this.setBookingDate(false, "COLLECTION");
  }

  setBookingDate(reset = false, type) {
    if (type === 'COLLECTION') {
      if (reset) {
        this.collectionTimeSlots = [];
      }

      if (this.bookingInfo.collectionInformation.scheduleDate) {
        if (reset) {
          this.bookingInfo.collectionInformation.timeSlot = {};
        }

        var selectedDate = this.availableCollectionDates.filter((x) => {
          return (
            moment(x.availableDate).format('YYYY-MM-DD') ===
            moment(this.bookingInfo.collectionInformation.scheduleDate).format('YYYY-MM-DD')
          );
        });
        if (selectedDate && selectedDate.length > 0) {
          this.collectionTimeSlots = selectedDate[0].slots.map((x, index) => {
            return { ...x, code: index + 1, name: x.label, value: x.label, slotStartTime: x.slotStartTime, slotEndTime: x.slotEndTime };
          });
          if (this.collectionTimeSlots.length == 1) {
            //this.bookingInfo.collectionInformation.slot = this.collectionTimeSlots[0];
            this.selectCollectionTimeSlot({value : this.collectionTimeSlots[0]});
          } else if (
            this.bookingInfo.collectionInformation &&
            this.bookingInfo.collectionInformation.scheduleTimeSlotStart
          ) {
            var index = this.collectionTimeSlots.findIndex((x) => {
              return x.slotStartTime === this.bookingInfo.collectionInformation.scheduleTimeSlotStart &&
              x.slotEndTime === this.bookingInfo.collectionInformation.scheduleTimeSlotEnd;
            });
            if (index > -1) {
              //this.bookingInfo.collectionInformation.slot = this.collectionTimeSlots[index];
              this.selectCollectionTimeSlot({value : this.collectionTimeSlots[index]});
            }
          }
        }
      }
    } else {
      if (reset) {
        this.deliveryTimeSlots = [];
      }
      if (this.bookingInfo.deliveryInformation.scheduleDate) {
        if (reset) {
          this.bookingInfo.deliveryInformation.timeSlot = {};
        }

        var selectedDate = this.availableDeliveryDates.filter((x) => {
          return (
            moment(x.availableDate).format('YYYY-MM-DD') ===
            moment(this.bookingInfo.deliveryInformation.scheduleDate).format('YYYY-MM-DD')
          );
        });
        if (selectedDate && selectedDate.length > 0) {
          this.deliveryTimeSlots = selectedDate[0].slots.map((x, index) => {
            return { ...x, code: index + 1, name: x.label, value: x.label, slotStartTime: x.slotStartTime, slotEndTime: x.slotEndTime };
          });
          if (this.deliveryTimeSlots.length == 1) {
            //this.bookingInfo.deliveryInformation.slot = this.deliveryTimeSlots[0];
            this.selectDeliveryTimeSlot({value : this.deliveryTimeSlots[0]});
          } else if (
            this.bookingInfo.deliveryInformation &&
            this.bookingInfo.deliveryInformation.scheduleTimeSlotStart
          ) {
            var index = this.deliveryTimeSlots.findIndex((x) => {
              return x.slotStartTime === this.bookingInfo.deliveryInformation.scheduleTimeSlotStart &&
              x.slotEndTime === this.bookingInfo.deliveryInformation.scheduleTimeSlotEnd;
            });
            if (index > -1) {
              //this.bookingInfo.deliveryInformation.slot = this.deliveryTimeSlots[index];
              this.selectDeliveryTimeSlot({value : this.deliveryTimeSlots[index]})
            }
          }
        }
        if(this.minCollectionDate < moment(this.bookingInfo.deliveryInformation.scheduleDate).add(1, 'day').toDate()){
          this.minCollectionDate = moment(this.bookingInfo.deliveryInformation.scheduleDate).add(1, 'day').toDate();
        }
      }
    }
  }

  datePickerClosed(event){
    if (this.bookingInfo.fromDate && !this.bookingInfo.toDate) {
      this.getAvailableProducts();
    }
  }

  datePickerFocused(event){
    this.selectedProductsTmp = this.products
      .filter((x) => {
        return x.selected;
      })
      .map((x) => {
        return x.id;
      });
  }

  onDeliveryMonthChange(date){
    this.deliveryTimeSlots = [];
    var fromDate = moment(new Date(date.year, date.month - 1, 1))
      .startOf('month')
      .format('YYYY-MM-DD');
    this.getAvailability(fromDate,false,false,true);
  }

  onCollectionMonthChange(date){
    this.collectionTimeSlots = [];
    var fromDate = moment(new Date(date.year, date.month - 1, 1))
      .startOf('month')
      .format('YYYY-MM-DD');
    this.getAvailability(fromDate,false,true,false);
  }

  selectDeliveryTimeSlot(event){
    this.bookingInfo.deliveryInformation.slot = event.value;

    this.bookingInfo.fromDate = moment(moment(this.bookingInfo.deliveryInformation.scheduleDate).format('YYYY-MM-DD')+"T"+this.bookingInfo.deliveryInformation.slot.slotEndTime).toDate();
    this.datesUpdated()
    this.getAvailableProducts();
    this.getMinCollectionDate();
    this.getMaxCollectionDate();
    this.getAvailability(this.bookingInfo.fromDate,false,true,false);
  }

  selectCollectionTimeSlot(event){
    this.bookingInfo.collectionInformation.slot = event.value;

    this.bookingInfo.toDate = moment(moment(this.bookingInfo.collectionInformation.scheduleDate).format('YYYY-MM-DD')+"T"+this.bookingInfo.collectionInformation.slot.slotStartTime).toDate();
    this.datesUpdated();
    this.getAvailableProducts();
  }


  getMinCollectionDate(){
    if(this.rentalStoreRules.allowFixedRentalOptions){
      this.minCollectionDate = this.bookingInfo.fromDate;
    }else{
      this.minCollectionDate = moment(this.bookingInfo.fromDate).add(this.rentalStoreRules.flexibleReservationConfiguration.minimumDurationValue, this.rentalStoreRules.flexibleReservationConfiguration.mimimumDurationUnitType == 1 ? 'hours' : this.rentalStoreRules.flexibleReservationConfiguration.mimimumDurationUnitType == 2 ? 'days' : 'days').toDate()
    }

    if(this.bookingInfo.collectionInformation && this.bookingInfo.collectionInformation.isCollection && moment(this.bookingInfo.fromDate).add(this.rentalStoreRules.minimumRentalDaysForCollection, 'day').toDate() > this.minCollectionDate){
      this.minCollectionDate = moment(this.bookingInfo.fromDate).add(this.rentalStoreRules.minimumRentalDaysForCollection, 'day').toDate();
    }
  }

  getMaxCollectionDate(){
    if(this.rentalStoreRules.allowFlexibleRentalOptions){
      this.maxCollectionDate = moment(this.bookingInfo.fromDate).add(this.rentalStoreRules.flexibleReservationConfiguration.maximumDurationValue, this.rentalStoreRules.flexibleReservationConfiguration.minimumDurationUnitType == 1 ? 'hours' : this.rentalStoreRules.flexibleReservationConfiguration.maximumDurationUnitType == 2 ? 'days' : 'days').toDate()
    }
  }

  getAccessoryCategories(accessories : any){    
    var categories = accessories.map((x) => { return x.categoryName});
    return [...new Set(categories)];
  }

  getAccessoryBrand(accessories : any){    
    var brands = accessories.map((x) => { return x.brand});
    return [...new Set(brands)];
  }

  getFilteredAccessories(accessories: any[], selectedCategory: string, selectedBrand: string): any[] {
    if (!accessories) return [];
    
    return accessories.filter(accessory => {
      // If no category or brand is selected, show all
      if (!selectedCategory && !selectedBrand) return true;
      
      // If only category is selected
      if (selectedCategory && !selectedBrand) {
        return accessory.categoryName === selectedCategory;
      }
      
      // If only brand is selected
      if (!selectedCategory && selectedBrand) {
        return accessory.brand === selectedBrand;
      }
      
      // If both category and brand are selected
      return accessory.categoryName === selectedCategory && accessory.brand === selectedBrand;
    });
  }

}
